const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/items/$id/images.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getQueryClient } from "@/lib/client";
import { generateItemMeta } from "@/lib/generate-item-meta";
import { getFetchedQuery } from "@/lib/get-fetched-query";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/lib/i18n";
export const Route = createFileRoute("/{-$locale}/items/$id/images")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context,
    params
  }) => {
    const {
      queryClient
    } = context;
    return {
      id: params.id,
      dehydratedState: dehydrate(queryClient)
    };
  },
  head: ctx => {
    const {
      params
    } = ctx;
    const queryClient = getQueryClient();
    if (!ctx.loaderData) {
      return {
        meta: [{
          title: i18n.t("items.notFound"),
          description: i18n.t("items.notFound")
        }]
      };
    }
    const item = getFetchedQuery<SingleItem>(queryClient, ctx.loaderData?.dehydratedState, ["item", {
      id: params.id
    }]);
    if (!item) {
      return {
        meta: [{
          title: i18n.t("items.notFound"),
          description: i18n.t("items.notFound")
        }]
      };
    }
    return {
      meta: generateItemMeta(item, i18n.t("items.images.title"))
    };
  }
});